<div class="dropzone" [ngClass]="{'draggingOver': draggingOver}">
  <input #fileInput type="file" (change)="onFileChange($event)" (dragover)="onDragOver()" (drop)="onDrop()" multiple
    class="fileInput" [disabled]="!enabled" />
  <div class="explanation text-center">

   <!-- <i class="fa-regular fa-folder-arrow-up" color="primary" aria-hidden="false" aria-label="Upload bestand"></i>-->

    <img src="/public/images/upload-files.svg" width="80px" />

    <h6><b>{{'dropzone.title'| translate}}</b></h6>
    <p>
       {{'or'| translate}} <a href="#" (click)="onAnchorClick($event)">{{'dropzone.click'| translate}}</a> {{'dropzone.toUpload' | translate}}
    </p>
    <!-- <p>
      (Maximaal XXXmb)
    </p> -->
  </div>
</div>
